import React, { FC }        from 'react';
import styled               from 'styled-components';
import { Tooltip }          from '@material-ui/core';
import { INote }            from '@typings/accountManagement';
import { getFormattedDate } from '@utils/commonFunctions';
import { Button }           from '@components/Button/Button';

const NoteContainer = styled.span`
  display         : flex;
  justify-content : space-between;
  align-items     : center;
  line-height     : 19px;
  height          : 70px;
  padding         : 0 15px;
`;

const NoteInfo = styled.p`
  flex         : 1;
  color        : ${({ theme: { textColor } }): string => textColor.gray};
  font-size    : 16px;
  font-weight  : 300;
  min-width    : 120px;
  margin-right : 15px;
`;

const NoteText = styled.p`
  flex          : 5;
  white-space   : nowrap;
  overflow      : hidden;
  text-overflow : ellipsis;
  margin-right  : 30px;
  min-width     : 70px;
`;

interface IProps {
  note                  : INote;
  handleToggleNoteModal : (note: INote | null) => void;
}

export const Note: FC<IProps> = ({ note, handleToggleNoteModal }) => (
  <NoteContainer>
    <NoteInfo>{getFormattedDate(note?.noteTime, 'MM/DD/YYYY')}</NoteInfo>

    <Tooltip title={note?.text} arrow>
      <NoteText>{note?.text}</NoteText>
    </Tooltip>

    <NoteInfo>{note?.authorFullName ?? 'User Name'}</NoteInfo>

    <Button
      label   = "View More"
      color   = "primary"
      width   = "85px"
      onClick = {() => handleToggleNoteModal(note)}
    />
  </NoteContainer>
);
